import { render, staticRenderFns } from "./GestaoInventarioDetails.vue?vue&type=template&id=b1ed1fc2"
import script from "./GestaoInventarioDetails.vue?vue&type=script&lang=js"
export * from "./GestaoInventarioDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports